import React, {Component} from 'react';
import TwoThreeRows from '../layouts/TwoThreeRows/TwoThreeRows';
import ContentPanel from '../components/ContentPanel/ContentPanel'
import Skeleton from '../components/Skeleton/Skeleton';
import BlankComponent from '../components/BlankComponent/BlankComponent';
import connect from "react-redux/es/connect/connect";
import {REQUEST_PRESS_RELEASES_DATA} from "../actions/pressReleasesActions";
import {REQUEST_NEWS_DATA} from "../actions/newsActions";
import NewsWidget from "../components/NewsWidget/NewsWidget";
import PressReleaseWidget from "../components/PressReleaseWidget/PressReleaseWidget";

const mapStateToProps = (state) => {
  return {
    pressReleasesData: state.pressReleasesData,
    newsData: state.newsData
  };
};

const mapDispatchToProps = dispatch => ({
  getPressReleasesData: () => dispatch({type: REQUEST_PRESS_RELEASES_DATA}),
  getNewsData: () => dispatch({type: REQUEST_NEWS_DATA})
});

class About extends Component {

  componentDidMount() {
    if (!Object.keys(this.props.newsData).length) {
      this.props.getNewsData();
    }
    if (!Object.keys(this.props.pressReleasesData).length) {
      this.props.getPressReleasesData();
    }
  };

  render() {
    return (
      <BlankComponent>
        <TwoThreeRows
          rows={3}

          mainPanel={
            <ContentPanel
              skeleton={<Skeleton type="MAIN_PANEL"/>}
              errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
              templateUrl="./content/about/page-components/text-block/about-landing-heading.html"
            />
          }

          contentPanel1={
            <ContentPanel
              skeleton={<Skeleton type="CONTENT_PANEL"/>}
              errorTemplate={<Skeleton type="CONTENT_PANEL_ERROR"/>}
              templateUrl="./content/about/page-components/article/about-landing/about-landing-tile-1.html"
            />
          }

          contentPanel2={
            <ContentPanel
              skeleton={<Skeleton type="CONTENT_PANEL"/>}
              errorTemplate={<Skeleton type="CONTENT_PANEL_ERROR"/>}
              templateUrl="./content/about/page-components/article/about-landing/about-landing-tile-2.html"
            />
          }

          contentPanel3={
            <ContentPanel
              skeleton={<Skeleton type="CONTENT_PANEL"/>}
              errorTemplate={<Skeleton type="CONTENT_PANEL_ERROR"/>}
              templateUrl="./content/about/page-components/article/about-landing/about-landing-tile-3.html"
            />
          }
        />
        <div className="basic-two-columns background-primary-blue">
          <div className="basic-two-columns__wrapper">
            <div className="basic-two-columns__row">
              <div className="basic-two-columns__column">
                <div className="basic-two-columns__feed basic-two-columns__feed--press-release">
                  <h2 className="basic-two-columns__feed-title color-white">Press Releases</h2>
                  {
                    Object.keys(this.props.pressReleasesData).length ? (
                      <PressReleaseWidget
                        pressReleases={this.props.pressReleasesData.pressReleases}
                        linkColorClass="color-white"
                      />
                    ) : <Skeleton type="MAIN_PANEL"/>
                  }
                </div>
              </div>
              <div className="basic-two-columns__column">
                <div className="basic-two-columns__feed basic-two-columns__feed--news">
                  <h2 className="basic-two-columns__feed-title color-white">News</h2>
                  {
                    Object.keys(this.props.newsData).length ? (
                      <NewsWidget
                        news={this.props.newsData.news}
                        linkColorClass="color-white"
                      />
                    ) : <Skeleton type="MAIN_PANEL"/>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlankComponent>
    )
  }
};

export default (connect(mapStateToProps, mapDispatchToProps)(About));



// WEBPACK FOOTER //
// ./src/pages/About.js